// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container-about{
  border: solid 2px #121212;
  transition: transform 50ms;
  max-width: 600px;
  font-family: IBM Plex Mono;
  padding: 12px 18px;
  background: rgb(255, 255, 255);

}
.br-m{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

}
.input-stl{
  border-radius: 50px;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
  max-width: 300px;
  /* display: flex;
  border-radius: 50px;
  border-style: none;
  outline: none;
  margin-top: 8px;
  padding: 12px 24px;
  background-color: #EAEEED; */
  /* max-height: 400px;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px; */
}
.link-acc {
  color: #000000;
  text-decoration: none;
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
}

.link-acc:hover {
text-decoration: underline;
}
.container-about-a{
border: solid 2px #121212;
transition: transform 50ms;
max-width: 600px;
font-family: IBM Plex Mono;
padding: 12px 18px;
background: rgb(255, 255, 255);

}
.container-about-info {
  border: solid 2px #121212;
  transition: transform 50ms;
  width: 90%;
  max-width: 1200px;
  min-width: 320px;
  font-family: IBM Plex Mono;
  padding: 20px;

  background: rgb(255, 255, 255);
}


.download-button {
  background-color: #ffffff;
  color: rgb(0, 0, 0);

  border: 2px solid #000000;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 15px;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: #e6f3ff;
}

.details-button {
  background-color: #ffa500;
}`, "",{"version":3,"sources":["webpack://./src/components/login/Login.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;;AAEzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;8BAM4B;EAC5B;;;;;wBAKsB;AACxB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;AACA,0BAA0B;AAC1B;AACA;AACA,yBAAyB;AACzB,0BAA0B;AAC1B,gBAAgB;AAChB,0BAA0B;AAC1B,kBAAkB;AAClB,8BAA8B;;AAE9B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;;EAEb,8BAA8B;AAChC;;;AAGA;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["\r\n.container-about{\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  max-width: 600px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 12px 18px;\r\n  background: rgb(255, 255, 255);\r\n\r\n}\r\n.br-m{\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n\r\n}\r\n.input-stl{\r\n  border-radius: 50px;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n  max-width: 300px;\r\n  /* display: flex;\r\n  border-radius: 50px;\r\n  border-style: none;\r\n  outline: none;\r\n  margin-top: 8px;\r\n  padding: 12px 24px;\r\n  background-color: #EAEEED; */\r\n  /* max-height: 400px;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n  padding-top: 30px;\r\n  padding-left: 20px;\r\n  padding-right: 20px; */\r\n}\r\n.link-acc {\r\n  color: #000000;\r\n  text-decoration: none;\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n}\r\n\r\n.link-acc:hover {\r\ntext-decoration: underline;\r\n}\r\n.container-about-a{\r\nborder: solid 2px #121212;\r\ntransition: transform 50ms;\r\nmax-width: 600px;\r\nfont-family: IBM Plex Mono;\r\npadding: 12px 18px;\r\nbackground: rgb(255, 255, 255);\r\n\r\n}\r\n.container-about-info {\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  min-width: 320px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 20px;\r\n\r\n  background: rgb(255, 255, 255);\r\n}\r\n\r\n\r\n.download-button {\r\n  background-color: #ffffff;\r\n  color: rgb(0, 0, 0);\r\n\r\n  border: 2px solid #000000;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.download-button:hover {\r\n  background-color: #e6f3ff;\r\n}\r\n\r\n.details-button {\r\n  background-color: #ffa500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
